import React, { FC } from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Link from '@material-ui/core/Link'
import Button from '@material-ui/core/Button'
import clsx from 'clsx'
import messages from '@configurator-messages'
import { FormattedMessage } from 'react-intl'
import { UploadType } from '../../utils/enum'
import { UploadGenomicsType } from '../../products/Genomics/enum'
import {
  ProductTypes,
  PlateProperties,
} from '../../../SemiConfigurators/products/KicqstartGeneArray/enum'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    margin: theme.spacing(1),
    width: theme.spacing(160),
    height: theme.spacing(18),
  },
  mgTop: {
    marginTop: theme.spacing(2),
  },
  title: {
    backgroundColor: theme.palette.grey[50],
  },
  titleText: {
    fontWeight: theme.typography.fontWeightBold,
  },
  button: {
    margin: theme.spacing(0, 6, 3, 0),
  },
  print: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.primary.main,
  },
  cancelink: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.primary.main,
    margin: theme.spacing(0, 6, 2, 0),
  },
  borderRaduis: {
    '& .MuiPaper-rounded': {
      borderRadius: 20,
    },
  },
}))

interface TermsAndConditionsProps {
  dialogOpen: boolean
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>
  saveToSession: any
  uploadDataType: string
  data: any
  prodType: any
}

const CautionPopUp: FC<TermsAndConditionsProps> = (props) => {
  const classes = useStyles()
  const {
    dialogOpen,
    setDialogOpen,
    saveToSession,
    uploadDataType,
    data,
    prodType,
  } = props

  const handleClose = () => {
    setDialogOpen(false)
  }

  const performSave = () => {
    setDialogOpen(false)
    saveToSession(uploadDataType, data)
  }

  return (
    <div className={clsx(dialogOpen && classes.root)}>
      <Dialog open={dialogOpen} maxWidth="md" className={classes.borderRaduis}>
        <DialogTitle className={classes.borderRaduis}>
          <h3 className={classes.titleText}>
            <FormattedMessage {...messages.CONF_CAUTION_HEADING} />
          </h3>
        </DialogTitle>
        <DialogContent className={clsx(classes.root, classes.mgTop)}>
          {prodType === UploadType.prodType ||
          prodType === UploadGenomicsType.prodType ? (
            <FormattedMessage {...messages.CONF_CAUTION_POPUP_TEXT_TUBES} />
          ) : prodType === ProductTypes.ProductType ? (
            <>
              <div>
                <FormattedMessage
                  {...messages.SEMICONF_CAUTION_POPUP_TEXT1}
                  values={{ type: PlateProperties[uploadDataType] }}
                />
              </div>
              <div>
                <FormattedMessage {...messages.SEMICONF_CAUTION_POPUP_TEXT2} />
              </div>
            </>
          ) : (
            <FormattedMessage {...messages.CONF_CAUTION_POPUP_TEXT} />
          )}
        </DialogContent>
        <DialogActions>
          <Link
            component="button"
            className={classes.cancelink}
            onClick={handleClose}
          >
            <FormattedMessage id="CANCEL_CART_ITEMS" defaultMessage="Cancel" />
          </Link>
          <Button
            onClick={performSave}
            color="primary"
            variant="contained"
            size="medium"
            className={classes.button}
          >
            <FormattedMessage {...messages.CONF_CONTINUE_DNA_PLATES} />
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default CautionPopUp
